const PRIORITY_COLORS = ['#FFA421', '#F5FF00', '#1BA223'];
const FALLBACK_COLORS = ['#2C8957', '#346A9C', '#DAAD38', '#876DA7', '#E07A5F', '#3D5A80', '#6D9F71', '#8F5D8C'];
const GOLDEN_ANGLE = 137.508;

const hashString = value => {
  let hash = 0;
  const normalizedValue = String(value);

  for (let i = 0; i < normalizedValue.length; i++) {
    hash = (hash << 5) - hash + normalizedValue.charCodeAt(i);
    hash |= 0;
  }

  return Math.abs(hash);
};

const buildFallbackColor = index => {
  const hue = Math.round((index * GOLDEN_ANGLE) % 360);
  const saturation = 58 - (index % 3) * 6;
  const lightness = 50 + (index % 2) * 6;
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
};

const pickFromPalette = (palette, startIndex, usedColors) => {
  for (let offset = 0; offset < palette.length; offset++) {
    const paletteColor = palette[(startIndex + offset) % palette.length];
    if (!usedColors.has(paletteColor)) {
      usedColors.add(paletteColor);
      return paletteColor;
    }
  }

  return null;
};

const generateColor = (key, usedColors) => {
  const normalizedKey = key === undefined || key === null || key === '' ? '__default__' : key;
  const shouldEnsureUniqueColor = usedColors instanceof Set;

  if (!shouldEnsureUniqueColor) {
    return PRIORITY_COLORS[hashString(normalizedKey) % PRIORITY_COLORS.length];
  }

  const priorityColor = pickFromPalette(PRIORITY_COLORS, 0, usedColors);
  if (priorityColor) {
    return priorityColor;
  }

  const fallbackStartIndex = hashString(normalizedKey) % FALLBACK_COLORS.length;
  const fallbackColor = pickFromPalette(FALLBACK_COLORS, fallbackStartIndex, usedColors);
  if (fallbackColor) {
    return fallbackColor;
  }

  let fallbackIndex = usedColors.size;
  while (true) {
    const generatedColor = buildFallbackColor(fallbackIndex);
    fallbackIndex++;
    if (!usedColors.has(generatedColor)) {
      usedColors.add(generatedColor);
      return generatedColor;
    }
  }
};

export default generateColor;
